import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../api/services/user.service';
import { AnalyticsService } from '../../api/services/analytics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  invalidLogin: boolean;
  isLoading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private userService: UserService,
    private toastr: ToastrService,
    private analyticsService: AnalyticsService) { }


    login(username: string, password: string) {
      this.isLoading = true;
      this.authService.login(username, password)
      .subscribe(async () => {
        this.isLoading = false;
        this.sendDataToAnalytics(this.authService.getUserId(), "Email")
        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        await this.userService.getCurrentUser(this.authService.getUserId());
        this.router.navigateByUrl(returnUrl || '/');
      },
      () => {
        this.isLoading = false;
        this.toastr.error('Invalid Username and/or Password', 'Bad authentication!', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      });
    }

    sendDataToAnalytics(userId: string, method: string) {
      this.analyticsService.trackLogin(userId, method);
    }
    ngOnInit() {}
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/login/login.component.ts